import { CONSTRAINT_KEYS, type ConstraintKey, type FuelsData } from './types';

export const EMPTY_CONSTRAINTS = Object.fromEntries(CONSTRAINT_KEYS.map((key) => [key, null])) as Record<ConstraintKey, number | null>;

/**
 * Réseau « test PUC » as captured on integration (network 231934043, site 231935802):
 * contracts, variable prices, RE2020 contributions and the « Test 33 » pollutant.
 */
export const INITIAL_FUELS: FuelsData = {
    contracts: [
        {
            id: 'fc-gaz',
            name: 'Contrat gaz',
            linkedUnits: 3,
            fixedPrice: 1,
            calorificValue: 3_600_000_000,
            description: '',
            variablePrices: [
                { date: '1900-01', price: 2 },
                { date: '2026-01', price: 1 },
                { date: '2026-02', price: 2 },
                { date: '2026-03', price: 3 },
                { date: '2026-04', price: 4 },
                { date: '2026-05', price: 5 },
            ],
            constraints: { ...EMPTY_CONSTRAINTS },
        },
        {
            id: 'fc-default',
            name: 'Centrale_Default',
            linkedUnits: 2,
            fixedPrice: 1,
            calorificValue: 3_600_000_000,
            description: '',
            variablePrices: [
                { date: '1900-01', price: 1 },
                { date: '3000-01', price: 1 },
            ],
            constraints: { ...EMPTY_CONSTRAINTS },
        },
    ],
    enrRates: [{ id: 'enr-re2020', name: 'RE2020', shares: { 'fc-gaz': 4, 'fc-default': 10 }, min: 14, max: 2, startDay: 1, startMonth: 1, endDay: 1, endMonth: 1, createdBy: { firstname: 'Salah Eddine', lastname: 'ZEMMOURI' }, creationDate: '2026-03-18T13:09:51', modificationDate: '2026-09-03T14:35:24' }],
    pollutants: [{ id: 'pol-test33', name: 'Test 33', emissions: { 'fc-gaz': 14, 'fc-default': 4 }, fixedPrice: 15, variablePrices: [{ date: '1900-01', price: 0 }, { date: '3000-12', price: 0 }], maxThreshold: 5, boundStart: '15-01', boundEnd: '31-02', createdBy: { firstname: 'Mourad', lastname: 'ABDELAZIZ' }, creationDate: '2026-08-27T16:36:45', modificationDate: '2026-09-03T14:34:08' }],
};

/** Production `FORM_NAME_MAX_LENGTH` (54, as displayed on integration for every fuels form). */
export const FORM_NAME_MAX = 54;
export const FUEL_CONTRACT_NAME_MAX = FORM_NAME_MAX;
export const ENR_RATE_NAME_MAX = FORM_NAME_MAX;
export const POLLUTANT_NAME_MAX = FORM_NAME_MAX;
export const DEFAULT_CALORIFIC_VALUE = 3_600_000_000;

export const CONSTRAINT_LABELS: Record<ConstraintKey, string> = {
    minHourly: 'Minimum horaire (u)',
    maxHourly: 'Maximum horaire (u)',
    minDaily: 'Minimum journalier (u)',
    maxDaily: 'Maximum journalier (u)',
    minMonthly: 'Minimum mensuel (u)',
    maxMonthly: 'Maximum mensuel (u)',
    minYearly: 'Minimum annuel (u)',
    maxYearly: 'Maximum annuel (u)',
};

export const TOOLTIPS = {
    calorificValue: "Quantité d'énergie thermique libérée lorsqu'une quantité spécifiée de substance est complètement brûlée dans des conditions standard",
    fuelConstraints: 'Permet de définir des quantités minimales et maximales de consommation sur un intervalle de temps',
    enrContributions:
        'Part de contribution de chaque contrat combustible au calcul des différents taux EnR. Ce calcul est fait en pourcentage de la production issue de chaque contrat et est associé aux contraintes définies ci‑dessous. Ex : 20 % de EnR_1 = 20 % de la production du contrat combustible comptabilisée comme EnR_1',
    enrThresholds: 'Permet de définir, pour chaque taux EnR, les bornes minimales et maximales à respecter dans le résultat de l’optimisation',
    variablePrice: 'Voir/Modifier les prix variables du contrat',
};
